import React from "react";
import { Building2, Zap, Cpu, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Gebäudeautomation",
  icon: Building2,
  description: "Individuelle Smart-Home- und Automationslösungen für Neubau, Umbau und Nachrüstung.",
  points: ["Licht & Beschattung", "Heizung & Lüftung", "Visualisierung & Szenen", "Inbetriebnahme & Feinoptimierung"]
}, {
  title: "Energieoptimierung",
  icon: Zap,
  description: "PV, Wärmepumpe, Speicher und Wallbox intelligent vernetzt – für mehr Eigenverbrauch und Effizienz.",
  points: ["PV-Integration", "Speicher-Einbindung", "Wärmepumpe & Boiler", "Wallbox & Lastmanagement"]
}, {
  title: "Steuerungstechnik & SPS",
  icon: Cpu,
  description: "Steuerungslösungen für Gebäude und technische Anlagen – strukturiert und dokumentiert.",
  points: ["Wago SPS-Programmierung", "Schnittstellenintegration", "Optimierung bestehender Systeme", "Fehleranalyse"]
}];
export default function UnsereLeistungen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="unsere-leistungen" className="dark bg-background text-foreground py-20 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/10 to-transparent" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-foreground">
            Technik, die zusammenspielt.
          </h2>
          <p className="text-lg text-muted-foreground">Wir verbinden Smart-Home, Energie und Steuerungstechnik zu einem intelligenten Gesamtsystem – individuell geplant, sauber umgesetzt und langfristig erweiterbar.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} data-index={index} className={`transition-all duration-500 delay-[${index * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                <Card className="h-full bg-card border-0 border-t-2 border-t-primary rounded-lg shadow-lg hover:-translate-y-2 transition-transform duration-300 group overflow-hidden">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                      <Icon className="w-6 h-6" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-bold text-card-foreground group-hover:text-primary transition-colors duration-300">
                      {service.title}
                    </CardTitle>
                    <p className="text-sm text-muted-foreground mt-2">
                      {service.description}
                    </p>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-2.5">
                      {service.points.map((point, idx) => <li key={idx} className="flex items-start gap-2.5 text-sm text-muted-foreground">
                          <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary/60 shrink-0" />
                          <span>{point}</span>
                        </li>)}
                    </ul>
                    {index === 0 && <p className="text-sm text-muted-foreground mt-2">Zertifizierter Loxone Partner</p>}
                    {service.title === "Loxone Partner" && <p className="text-sm text-muted-foreground mt-2">Zertifizierter Loxone Partner</p>}
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className={`mt-16 text-center transition-all duration-700 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium px-8">
            <Link to="/ContactPage">
              Projekt anfragen <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}